import React from "react";
import ReusableDataTable from "../../hooks/ReusableDataTable";
import { Button, Checkbox, Label, Modal, TextInput ,Select} from "flowbite-react";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import '../../style/model.css';
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import useInputValidation from "../../hooks/useInputValidation";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import axios from "axios";
import { useSidebar } from "../../context/SidebarOpenContext";

function Style() {
    const [AddModal, setAddModal] = useState(false);
    const [EditModal, setEditModal] = useState(false);
    const [DeleteModal, setDeleteModal] = useState(false);
    const [Input, setInput] = useState({});
    const [Style, setStyle] = useState({});
    const { errors, handleChange, resetErrors } = useInputValidation();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    useEffect(() => {
        fetchstyle();
    }, []);


    const onChangeValue = (e) => {
        handleChange(e);
        setInput({ ...Input, [e.target.name]: e.target.value });
    }

    const fetchstyle = async () => {
        try {
            const response = await axios.get("master/styles");
            const StyleData = response.data;
            setStyle(StyleData);
        } catch (error) {
            console.error("Error fetching Style data:", error);
        }
    };

    const addStyle = async (event) => {
        event.preventDefault();
        try {
            axios
                .post(`master/styles`, {
                    style_name: Input.sname,
                    style_no: Input.style_no,
                    size_variant_type:Input.markertype,
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Style  Created",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setAddModal(false);
                        fetchstyle();


                    } else if (res.data.success === 2) {
                        Swal.fire({
                            icon: "error",
                            text: "Style  already exists...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };

    const UpdateStyle = async (event) => {
        event.preventDefault();

        try {
            axios
                .put(`master/styles/${Input.id}`, {
                    style_name: Input.sname,
                    style_no: Input.style_no,
                    style_id: Input.id,
                    size_variant_type:Input.markertype,
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Style  Details Updated",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setEditModal(false);
                        fetchstyle();
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };

    const deletStyle = async () => {
        try {
            axios.delete(`master/styles/${Input.id}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Style  deleted",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    fetchstyle();
                    setDeleteModal(false);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        type: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
                return;
            });
        } catch (error) {
            throw error;
        }
    };


    const data = Array.isArray(Style)
        ? Style.map((S) => ({
            id: S.style_id,
            sname: S.style_name,
            style_no: S.style_no,
            markertype: S.size_variant_type,
            option: (<div style={{ display: "flex" }}>
                <FaPen className="text-amber-400 text-xl" onClick={() => {
                    setEditModal(true); setInput({
                        id: S.style_id,
                        sname: S.style_name,
                        style_no: S.style_no,
                        markertype:S.size_variant_type,
                    });
                }} />
                <MdDeleteForever className="ml-2 text-red-500 text-2xl" onClick={() => { setDeleteModal(true); setInput({ id: S.style_id }) }} />
            </div>)
        }))
        : [];

    const columns = [
        { name: "S.No", selector: (row, index) => index + 1, sortable: true },
        { name: "Style Name", selector: (row) => row.sname, sortable: true },
        { name: "Style No", selector: (row) => row.style_no, sortable: true },
        { name: "Size Type", selector: (row) => row. markertype, sortable: true },
        { name: "Option", selector: (row) => row.option },
    ];

    return (
        <div className={` ${ isSidebarOpen  ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >

            <div className="p-4 rounded-lg dark:border-gray-700  mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" onClick={() => setAddModal(true)} >Add Style</Button>
                    <ReusableDataTable
                        title="Style List"
                        columns={columns}
                        data={data}
                    />
                </div>
            </div>

            <Modal show={AddModal} size="md" onClose={() => { setAddModal(false); resetErrors(); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Add Style</h3>
                        <form onSubmit={addStyle}>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.sname && "failure"} value="Style Name" />
                                </div>
                                <TextInput
                                    id="sname"
                                    name="sname"
                                    placeholder=""
                                    type="text"
                                    color={errors.sname && "failure"}
                                    helperText={
                                        errors.sname && (
                                            <>
                                                <span className="font-medium"></span> {errors.sname}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    pattern="^[a-zA-Z0-9\s]*$"
                                    required
                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.style_no && "failure"} value="Style No" />
                                </div>
                                <TextInput
                                    id="style_no"
                                    name="style_no"
                                    placeholder=""
                                    type="text"
                                    color={errors.style_no && "failure"}
                                    helperText={
                                        errors.style_no && (
                                            <>
                                                <span className="font-medium"></span> {errors.style_no}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    // pattern="^[a-zA-Z0-9\s]*$"
                                    required
                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="stock" value="Size Type" />
                                </div>
                                <Select id="markertype" name="markertype" onChange={onChangeValue}  required>
                                    <option value="">Select an option</option>
                                    <option value="numbers">Numbers</option>
                                    <option value="letters">Letters</option>
                                    <option value="Albanumeric">Albanumeric</option>
                                    
                                </Select>
                            </div>
                            <div className="pt-2 w-full flex justify-center">
                                <Button type="submit" className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => { setAddModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={EditModal} size="md" onClose={() => { setEditModal(false); resetErrors(); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Update Style</h3>
                        <form onSubmit={UpdateStyle}>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.sname && "failure"} value="Style Name" />
                                </div>
                                <TextInput
                                    id="sname"
                                    name="sname"
                                    placeholder=""
                                    type="text"
                                    color={errors.sname && "failure"}
                                    helperText={
                                        errors.sname && (
                                            <>
                                                <span className="font-medium"></span> {errors.sname}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    pattern="^[A-Za-za-zA-Z0-9\s]*$"
                                    required
                                    value={Input.sname}
                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.style_no && "failure"} value="Style No" />
                                </div>
                                <TextInput
                                    id="style_no"
                                    name="style_no"
                                    placeholder=""
                                    type="text"
                                    color={errors.style_no && "failure"}
                                    helperText={
                                        errors.style_no && (
                                            <>
                                                <span className="font-medium"></span> {errors.style_no}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    // pattern="^[A-Za-za-zA-Z0-9\s]*$"
                                    required
                                    value={Input.style_no}
                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="stock" value="Size Type" />
                                </div>
                                <Select id="markertype" name="markertype" onChange={onChangeValue} value={Input.markertype}  required>
                                    <option value="">Select an option</option>
                                    <option value="numbers">Numbers</option>
                                    <option value="letters">Letters</option>
                                    <option value="Albanumeric">Albanumeric</option>
                                </Select>
                            </div>
                            <div className="pt-2 w-full flex justify-center">
                                <Button type="submit" className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => { setEditModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={DeleteModal} size="md" onClose={() => setDeleteModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to delete this style?
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button color="failure" onClick={() => deletStyle()}>
                                {"Yes"}
                            </Button>
                            <Button color="gray" onClick={() => setDeleteModal(false)}>
                                No
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </div>


    );
}

export default Style;
